/**
 * Paywall route — DISABLED for Wave G soft launch.
 * Founder directive (2026-05-12): no monetization in TMA. Any user landing here
 * sees a "Free beta — все функции открыты" message and is redirected to /today.
 *
 * Route stays mounted so old links don't 404; the page is intentionally a placeholder.
 * When monetization re-enables (Wave I+), replace with the real paywall.
 */
import { useNavigate } from "@tanstack/react-router";
import { type ReactElement, useEffect } from "react";

export default function PaywallPage(): ReactElement {
  const navigate = useNavigate();

  useEffect(() => {
    const t = window.setTimeout(() => {
      void navigate({ to: "/", replace: true });
    }, 1600);
    return () => window.clearTimeout(t);
  }, [navigate]);

  return (
    <main className="screen starry">
      <div className="body-pad" style={{ display: "flex", alignItems: "center" }}>
        <div style={{ textAlign: "center", margin: "auto", maxWidth: 280 }}>
          <div className="pw-badge">Free beta</div>
          <h2 className="ob-title ob-title--sm">
            Все функции <em>открыты</em>
          </h2>
          <p className="ob-sub">
            Пока мы в открытой бета-версии — натальная карта, транзиты и AI работают без оплаты.
            Возвращаем вас на главный экран.
          </p>
        </div>
      </div>
    </main>
  );
}
